t = require('views/internal/teacup-with-helpers')('popover_member_searcher')

module.exports = ->
  t.mustacheBlock 'showSearch', ->
    t.input '.js-filter-members.js-autofocus', { type: 'text', placeholder: t.l('search-members-ellipsis') }

  t.ul '.pop-over-member-list.checkable.js-members-list'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_member_searcher.coffee